import { network } from 'services/network';

import { GetTemplateByKeyRequestBody, QueryParams } from 'api/queries/getTemplateByKey';

export const getTemplateByKey = ({ componentKey, componentId }: QueryParams) => {
    const url = `api/bo/narratives/getTemplateByKey`;
    const body: GetTemplateByKeyRequestBody = {
        componentKey,
        componentId,
        forCurrentCustomerOnly: true,
    };

    return network.post(url, body).then((response) => {
        return response.data;
    });
};
